import React, { Component } from "react";

interface IErrorBoundaryProps {
	children: React.ReactNode;
}

interface IErrorBoundaryViewState {
	error: Error | null;
	errorInfo: React.ErrorInfo | null;
	hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryViewState> {
	constructor(props: IErrorBoundaryProps) {
		super(props);

		this.state = {
			error: null,
			errorInfo: null,
			hasError: false
		};
	}

	static getDerivedStateFromError(error: Error) {
		return { error: error };
	}

	componentDidCatch( error: Error, errorInfo: React.ErrorInfo ): void {
		this.setState({
			error: error,
			errorInfo: errorInfo,
			hasError: true
		});
		console.log( "error: " + error.name );
	}

	render() {
		if ( this.state.hasError ) {
			return (
				<div>
					<h1> Something went wrong. </h1>
					<details>
						{ this.state.error && this.state.error.toString() }
						<br />
						{ this.state.errorInfo?.componentStack }
					</details>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
